import React from "react";
import styles from "./HeaderFormPage.module.scss";

type HeaderFromPageProps = {
  title: string;
  subtitle: string;
};

export const HeaderFromPage = (props: HeaderFromPageProps) => {
  const { title, subtitle } = props;

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.title}>{title}</h2>
      <h3 className={styles.subtitle}>{subtitle}</h3>
    </div>
  );
};
